import instance from "../service/axiosConfig";
import publicInstance from "../service/axiosPublicInstance";
import axios from "axios";
//API method

//get method
export const getData = async (URL, headers) => {
  try {
    const response = await publicInstance.get(`${URL}`, headers);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getInstantData = async (URL, headers) => {
  try {
    const response = await instance.get(`${URL}`, headers);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Function for making a POST request
export const postData = async (URL, data, headers) => {
  try {
    const response = await publicInstance.post(`${URL}`, data, headers);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postInstantData = async (URL, data, headers) => {
  try {
    const response = await instance.post(`${URL}`, data, headers);
    return response;
  } catch (error) {
    throw error;
  }
};

export const putInstantData = async (URL, data, headers) => {
  try {
    const response = await instance.put(`${URL}`, data, headers);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteInstantData = async (URL, headers) => {
  try {
    const response = await instance.delete(`${URL}`, headers);
    // console.log("dsfghjk");
    return response;
  } catch (error) {
    return error.response.data;
    // throw error;
  }
};

export const postFormData = async (URL, data) => {
  try {
    axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
    const response = await instance.post(`${URL}`, data);
    axios.defaults.headers.common["Content-Type"] = "application/json";
    return response;
  } catch (error) {
    throw error;
  }
};

export const downloadFileMethod = async (URL, headers = {}, defaultFileName = "data.xlsx") => {
  try {
    const response = await instance.get(URL, {
      headers,
      responseType: "blob",
    });

    const blob = new Blob([response.data], { type: "text/xlsx" });

    const fileURL = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = fileURL;

    const contentDisposition = response.headers["content-disposition"];
    let fileName = defaultFileName;
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?(.+)"?/);
      if (match?.[1]) fileName = match[1];
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return true;
  } catch (error) {
    console.error("xlsx download failed:", error);
    throw error;
  }
};